import { useContext, useState } from "react"
import { OpenInNew } from "@mui/icons-material"
import { Box, Button, Paper } from "@mui/material"
import PlotlyChart from "components/plotly-chart"
import { useAnalytics } from "connected-components/analytics"
import { useIsAiModulePinningEnabled } from "resources/account"
import { AI_TEAMMATE_EVENTS } from "../../analytics"
import { ARTIFACT_KINDS } from "connected-components/dashboard/modules/ai-artifact/types"
import { PLOT_ARTIFACT } from "../../helpers/shapes"
import { AiContext } from "../../context/ai-context"
import FullSizeArtifactDialog from "../full-size-artifact-dialog"
import PinArtifactButton from "../pin-artifact-button"
import "./style.scss"

export default function PlotArtifact({ artifact }) {
  const analytics = useAnalytics()
  const [fullSizeOpen, setFullSizeOpen] = useState(false)
  const isAiModulePinningEnabled = useIsAiModulePinningEnabled()
  const aiContext = useContext(AiContext)
  const canPinArtifacts = aiContext?.canPinArtifacts ?? false

  function toggleFullSizePlot() {
    if (!fullSizeOpen) {
      analytics.track(AI_TEAMMATE_EVENTS.PLOT_EXPANDED)
    }
    setFullSizeOpen(!fullSizeOpen)
  }

  return <Box className="ai-teammate-plot-artifact">
    <Paper>
      <PlotlyChart className="chart-preview" {...artifact.figure} />
    </Paper>
    <Box className="plot-artifact-actions">
      <Button size="small" className="view-all-button" variant="outlined" color="primary" startIcon={<OpenInNew />} onClick={toggleFullSizePlot}>Show Full Plot</Button>
      {isAiModulePinningEnabled && canPinArtifacts && <PinArtifactButton artifact={artifact} kind={ARTIFACT_KINDS.PLOT} />}
    </Box>
    <FullSizeArtifactDialog
      open={fullSizeOpen}
      onClose={toggleFullSizePlot}
      title="Generated Plot"
    >
      <PlotlyChart className="chart-full-size" {...artifact.figure} />
    </FullSizeArtifactDialog>
  </Box>
}

PlotArtifact.propTypes = {
  artifact: PLOT_ARTIFACT.isRequired,
}
